export default "__VITE_ASSET__CdlCIwXh__"